import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace PublicProfileModels {
/** 
 * PublicOthersDtoSchema 
 * @type { object }
 * @property { CommonModels.AchievementOrAwardDto[] } achievements_or_awards  
 * @property { CommonModels.LicenseOrCertificationDto[] } licenses_or_certifications  
 * @property { CommonModels.VolunteerExperienceDto[] } volunteer_experiences  
 */
export const PublicOthersDtoSchema = z.object({ achievements_or_awards: z.array(CommonModels.AchievementOrAwardDtoSchema).nullable(), licenses_or_certifications: z.array(CommonModels.LicenseOrCertificationDtoSchema).nullable(), volunteer_experiences: z.array(CommonModels.VolunteerExperienceDtoSchema).nullable() }).partial();
export type PublicOthersDto = z.infer<typeof PublicOthersDtoSchema>;


/** 
 * PublicProfileV2DataDtoSchema 
 * @type { object }
 * @property { CommonModels.PersonDto } person  
 * @property { CommonModels.CompanyDto[] } companies  
 * @property { CommonModels.EducationDto[] } education  
 * @property { PublicOthersDto } others  
 */
export const PublicProfileV2DataDtoSchema = z.object({ person: CommonModels.PersonDtoSchema, companies: z.array(CommonModels.CompanyDtoSchema).nullish(), education: z.array(CommonModels.EducationDtoSchema).nullish(), others: PublicOthersDtoSchema.nullish() });
export type PublicProfileV2DataDto = z.infer<typeof PublicProfileV2DataDtoSchema>;


/** 
 * PublicUserDtoSchema 
 * @type { object }
 * @property { string } id  
 * @property { string } email Email from user 
 * @property { string } name Name from user 
 * @property { string } firstName  
 * @property { string } lastName  
 */
export const PublicUserDtoSchema = z.object({ id: z.string(), email: z.string().nullable(), name: z.string().nullable(), firstName: z.string().nullable(), lastName: z.string().nullable() });
export type PublicUserDto = z.infer<typeof PublicUserDtoSchema>;


/** 
 * PublicProfileResponseDtoSchema 
 * @type { object }
 * @property { string } id  
 * @property { string } userId  
 * @property { PublicUserDto } user  
 * @property { string } profilePictureId  
 * @property { string } profilePictureUrl  
 * @property { string } introductionCoverImageId  
 * @property { string } introductionCoverImageUrl  
 * @property { string } introductionVideoUrl  
 * @property { string } introductionVideoThumbnailUrl  
 * @property { string } introductionTitle  
 * @property { string } introductionBio  
 * @property { string } jobPosition  
 * @property { number } jobSalary  
 * @property { string } city  
 * @property { string } state  
 * @property { PublicProfileV2DataDto } dataV02  
 * @property { string } generatedAt  
 * @property { CommonModels.WorthNumbersDto } worthData  
 */
export const PublicProfileResponseDtoSchema = z.object({ id: z.string(), userId: z.string(), user: PublicUserDtoSchema.nullish(), profilePictureId: z.string().nullable(), profilePictureUrl: z.string().nullish(), introductionCoverImageId: z.string().nullable(), introductionCoverImageUrl: z.string().nullish(), introductionVideoUrl: z.string().nullish(), introductionVideoThumbnailUrl: z.string().nullish(), introductionTitle: z.string().nullish(), introductionBio: z.string().nullish(), jobPosition: z.string().nullish(), jobSalary: z.number().nullish(), city: z.string().nullish(), state: z.string().nullish(), dataV02: PublicProfileV2DataDtoSchema.nullable(), generatedAt: z.iso.datetime({ offset: true }).nullish(), worthData: CommonModels.WorthNumbersDtoSchema });
export type PublicProfileResponseDto = z.infer<typeof PublicProfileResponseDtoSchema>;


/** 
 * PublicProfilePictureDtoSchema 
 * @type { object }
 * @property { string } url  
 */
export const PublicProfilePictureDtoSchema = z.object({ url: z.string().nullable() });
export type PublicProfilePictureDto = z.infer<typeof PublicProfilePictureDtoSchema>;


/** 
 * GetEndorsementsResponseSchema 
 * @type { array }
 */
export const GetEndorsementsResponseSchema = z.array(CommonModels.EndorsementDtoSchema);
export type GetEndorsementsResponse = z.infer<typeof GetEndorsementsResponseSchema>;


}
